<template>
  <el-select
    v-model="userModel"
    @change="userChanged"
    autocomplete="new-password"
    :placeholder="placeholder ? placeholder : $t('COMMON.USER')"
    :filterable="filterable"
    :multiple="false"
    :disabled="disabled"
    remote
    :remote-method="getUsers"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="placeholder ? placeholder : $t('COMMON.ALL_USERS')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="user in users"
      :key="user.id"
      :value="user.id"
      :label="`${user.firstname} ${user.lastname} - ${user.email}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "user-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    placeholder: {
      type: String,
      default: null,
      description: "Placeholder of input",
    },
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    user: {
      type: String,
      default: null,
      description: "User id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterOrganizationNull: {
      type: Boolean,
      default: null,
      description: "Filter only null organizations",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    filterResellerNull: {
      type: Boolean,
      default: null,
      description: "Filter only null resellers",
    },
    filterPermission: {
      type: String,
      default: null,
      description: "Permission name",
    },
    ignoreLocationFilter: {
      type: Boolean,
      default: false,
    },
    withDoesntHave: {
      type: Boolean,
      default: false,
    },
    filterLocation: {
      type: String | Number,
      default: null,
    },
  },

  data() {
    return {
      userModel: this.user,
      users: {},
    };
  },

  setup() {},

  created() {
    this.getUsers(null, this.user);
  },

  methods: {
    async getUsers(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "firstname",
          filter: {
            ...(query ? { search: query } : {}),
            ...(id ? { with_ids: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterOrganizationNull) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: null,
            },
          };
        }
        if (this.filterReseller) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              reseller: this.filterReseller,
            },
          };
        }
        if (this.filterResellerNull) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              reseller: null,
            },
          };
        }
        if (this.filterPermission) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              permission: this.filterPermission,
            },
          };
        }
        if (this.filterLocation) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              allowedLocations: this.filterLocation,
            },
          };
        }
        if (this.ignoreLocationFilter) {
          params = {
            ...params,
            ignore_location_filter: true,
          };
        }
        if (this.withDoesntHave) {
          params = {
            ...params,
            with_doesnt_have: true,
          };
        }

        await this.$store.dispatch("users/list", params);
        const usersArr = await this.$store.getters["users/list"];
        this.users = {};
        usersArr.forEach((user) => {
          this.users[user.id] = user;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    userChanged(userId) {
      const user = Object.values(this.users).find((item) => item.id === userId);
      this.$emit("userChanged", userId, user);
    },
  },

  watch: {
    user(user) {
      if (user) {
        this.userModel = user;
        if (user !== this.userModel) {
          this.getUsers(null, user);
        }
      } else {
        this.userModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getUsers();
    },
    filterOrganizationNull(filterOrganization) {
      this.getUsers();
    },
    filterReseller(filterReseller) {
      this.getUsers();
    },
    filterResellerNull(filterReseller) {
      this.getUsers();
    },
    ignoreLocationFilter() {
      this.getUsers();
    },
    filterLocation() {
      this.getUsers();
    },
    withDoesntHave() {
      this.getUsers();
    },
  },
};
</script>
